/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerConfigClerk
 */
export interface CustomerConfigClerk {
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigClerk
     */
    webhookSecret?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigClerk
     */
    secretKey?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfigClerk
     */
    publishableKey?: string | null;
}

/**
 * Check if a given object implements the CustomerConfigClerk interface.
 */
export function instanceOfCustomerConfigClerk(value: object): value is CustomerConfigClerk {
    return true;
}

export function CustomerConfigClerkFromJSON(json: any): CustomerConfigClerk {
    return CustomerConfigClerkFromJSONTyped(json, false);
}

export function CustomerConfigClerkFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerConfigClerk {
    if (json == null) {
        return json;
    }
    return {
        
        'webhookSecret': json['webhookSecret'] == null ? undefined : json['webhookSecret'],
        'secretKey': json['secretKey'] == null ? undefined : json['secretKey'],
        'publishableKey': json['publishableKey'] == null ? undefined : json['publishableKey'],
    };
}

export function CustomerConfigClerkToJSON(value?: CustomerConfigClerk | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'webhookSecret': value['webhookSecret'],
        'secretKey': value['secretKey'],
        'publishableKey': value['publishableKey'],
    };
}

